import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import { useMediaQuery } from "@uidotdev/usehooks";
import Form from "./Form";
import Footer from "./Footer";

import imageGradUvod from "../catalog/formiranje-grada1.jpg";
import imageGradUvod2 from "../catalog/formiranje-grada2.jpg";
import imageGradUvod3 from "../catalog/formiranje-grada3.jpg";
import imageGradUvod4 from "../catalog/formiranje-grada4.jpg";

import gradMetodologija1 from "../catalog/grad-metodologija1.png";
import gradMetodologija2 from "../catalog/grad-metodologija2.png";
import gradMetodologija4 from "../catalog/grad-metodologija4.jpg";

import gradTrendovi1 from "../catalog/grad-trend1.jpg";
import gradTrendovi2 from "../catalog/grad-trend2.jpg";
import gradTrendovi3 from "../catalog/grad-trendovi-3grafikona.png";

import gradKlimatologija from "../catalog/grad-klimatologija.gif";

import gradStete1 from "../catalog/grad-stete-1.png";
import gradStete2 from "../catalog/grad-stete-2.png";
import gradStete3 from "../catalog/grad-stete-3.png";
import gradStete4 from "../catalog/grad-stete-4.png";

import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import ReactHtmlParser from "html-react-parser";

const FlexibleContent = ({ items }) => {
  return (
    <div className="space-y-6">
      {items.map((item, index) => {
        if (item.type === "images-side-by-side") {
          return (
            <div key={index}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {item.images.map((img, i) => (
                  <div key={i}>{ReactHtmlParser(img)}</div>
                ))}
              </div>
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }
        if (item.type === "images-side-by-side-desc") {
          return (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {item.images.map((el, i) => (
                <div key={i} className="flex flex-col">
                  {el.img && ReactHtmlParser(el.img)}

                  {el.desc && (
                    <p className="mt-2 text-sm text-gray-700">{el.desc}</p>
                  )}
                </div>
              ))}
            </div>
          );
        }

        if (item.type === "image-full") {
          return (
            <div key={index}>
              <div className="w-full">{ReactHtmlParser(item.image)}</div>
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }

        if (item.type === "text") {
          return (
            <div key={index} className="my-4">
              {ReactHtmlParser(item.content)}
            </div>
          );
        }

        if (item.type === "table") {
          return (
            <div key={index} className="overflow-x-auto my-4">
              {ReactHtmlParser(item.content)}
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

export default function Grad() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const isTabletOrLarger = useMediaQuery("only screen and (min-width: 769px)");
  const [activeTab, setActiveTab] = useState("formiranje-grada");

  const GRAD_DATA = {
    5: [
      { date: "28. 05. 2007.", file: "07052812.jpg" },
      { date: "9. 6. 2007.", file: "07060912.jpg" },
      { date: "23. 6. 2007.", file: "07062300.jpg" },
      { date: "20. 8. 2007.", file: "07082000.jpg" },
      { date: "11. 6. 2008.", file: "08061112.jpg" },
      { date: "10. 6. 2009.", file: "09061012.jpg" },
      { date: "28. 6. 2009.", file: "09062900.jpg" },
      { date: "12. 5. 2010.", file: "10051212.jpg" },
      { date: "14. 6. 2010.", file: "10061412.jpg" },
      { date: "16. 6. 2010.", file: "10061612.jpg" },
      { date: "19. 6. 2010.", file: "10061900.jpg" },
      { date: "18. 7. 2010.", file: "10071812.jpg" },
      { date: "31. 7. 2010.", file: "10073112.jpg" },
      { date: "8. 6. 2011.", file: "11060812.jpg" },
      { date: "10. 6. 2012.", file: "12061012.jpg" },
      { date: "22. 6. 2012.", file: "12062212.jpg" },
      { date: "11. 5. 2013.", file: "13051112.jpg" },
      { date: "17. 5. 2013.", file: "13051712.jpg" },
      { date: "30. 5. 2013.", file: "13053012.jpg" },
      { date: "10. 6. 2013.", file: "13061012.jpg" },
      { date: "22. 6. 2013.", file: "13062212.jpg" },
      { date: "17. 6. 2014.", file: "14061712.jpg" },
      { date: "27. 7. 2014.", file: "14072712.jpg" },
      { date: "24. 5. 2016.", file: "16052412.jpg" },
      { date: "19. 6. 2016.", file: "16061912.jpg" },
      { date: "20. 6. 2016.", file: "16062012.jpg" },
      { date: "23. 5. 2017.", file: "17052312.jpg" },
      { date: "3. 6. 2018.", file: "18060312.jpg" },
      { date: "22. 7. 2018.", file: "18072212.jpg" },
      { date: "19. 5. 2019.", file: "19051912.jpg" },
      { date: "28. 5. 2019.", file: "19052812.jpg" },
      { date: "7. 7. 2019.", file: "19070712.jpg" },
    ],

    6: [
      { date: "4. 8. 2006.", file: "06080412.jpg" },
      { date: "22. 5. 2007.", file: "07052212.jpg" },
      { date: "19. 6. 2007.", file: "07062000.jpg" },
      { date: "10. 8. 2007.", file: "07081012.jpg" },
      { date: "5. 6. 2009.", file: "09060512.jpg" },
      { date: "8. 7. 2009.", file: "09070812.jpg" },
      { date: "18. 6. 2010.", file: "10061812.jpg" },
      { date: "6. 8. 2009.", file: "10080612.jpg" },
      { date: "24. 6. 2011.", file: "11062400.jpg" },
      { date: "20. 7. 2011.", file: "11072012.jpg" },
      { date: "23. 6. 2013.", file: "13062300.jpg" },
      { date: "28. 8. 2013.", file: "13082812.jpg" },
      { date: "24. 6. 2014.", file: "14062412.jpg" },
      { date: "25. 6. 2014.", file: "14062512.jpg" },
      { date: "23. 8. 2014.", file: "14082312.jpg" },
      { date: "23. 6. 2019.", file: "19062312.jpg" },
    ],

    7: [
      { date: "13. 6. 2018.", file: "18061312.jpg" },
      { date: "15. 8. 2020.", file: "20081512.jpg" },
    ],
  };
  {
    /* 
  const GRAD_ZIP_DATA = {
    5: "/grad-data/extremes-grad-emagram-code5.zip",
    6: "/grad-data/extremes-grad-emagram-code6.zip",
    7: "/grad-data/extremes-grad-emagram-code7.zip",
  };
*/
  }
  const [hailCode, setHailCode] = useState("5");
  const [hailDate, setHailDate] = useState(GRAD_DATA["5"][0].file);

  useEffect(() => {
    if (GRAD_DATA[hailCode]?.length) {
      setHailDate(GRAD_DATA[hailCode][0].file);
    }
  }, [hailCode]);

  const data = [
    {
      label: "FORMIRANJE GRADA",
      value: "formiranje-grada",
      desc:
        `<h2>Uvod</h2>
      <p style="margin-bottom: 10px; color: #000;">
Grad je padavina leda u obliku loptica ili nepravilnih grudvica. Može biti providan ili delimično ili potpuno neproziran. Obično je sferoidnog, koničnog ili nepravilnog oblika prečnika 5–50 mm. Zrna leda čiji je prečnik manji od 5 mm se, po dogovoru, nazivaju sugradica. Grad je glavna meteorološka opasnost u Evropi, gde pojedinačne padavine grada prouzrokuju gubitke od milijardu evra. On je prethodnih godina izazvao rekordne gubitke koji prelaze pet milijardi u Francuskoj 2022. g. i Italiji 2023. g. (Cusack i Cox, 2024). To je razarajući meteorološki fenomen za kritičnu infrastrukturu, zgrade, motorna vozila, posebno za poljoprivredne useve. Naš narod je znao da kaže da je letinu ubio led: za 15–20 minuta grad uništi svu berbu grožđa i voća i opustoši žitna polja. 
      </p>` +
        `<p style="margin-bottom: 10px; color: #000;">
Grad uvek nastaje u konvektivnim oblacima, skoro uvek u kumulonimbusima. U njima postoje jake uzlazne struje koje podižu vazduh na veće visine i time obezbeđuju kondenzaciju vodene pare. Tako se formira veliki broj prehlađenih oblačnih kapljica. U takvoj sredini, embrion grada (bilo da je to smrznuta kišna kap ili graupel) se sudara sa prehlađenim kapljicama koje se mrznu na njemu i tako se formira grad. Što duže zrno grada boravi u oblaku nošeno uzlaznom strujom, prikupiće veću količinu prehlađenih oblačnih kapljica, pa će narasti do većih dimenzija.  Grad se formira na visinama gde je temperatura vazduha između -10°C i -30°C.  Što je veća vertikalna brzina u kumulonimbusu, veća su i zrna grada koja ta struja može da održi u vazduhu. 
       </p>` +
        `<p style="margin-bottom: 16px; color: #000;">
Kako grad raste i postaje teži, u jednom trenutku njegova brzina padanja postaje veća od brzine uzlazne struje vazduha u kumulonimbusu. Tada on počinje da pada ka tlu i pri tome takođe raste, jer prikuplja prehlađene oblačne kapljice i kišne kapi koje mu se nađu na putu. Može da bude opet zahvaćen jakom uzlaznom strujom koja ga nosi naviše, čime se njegov rast pospešuje. To je recirkulacija, ključni mehanizam za formiranje krupnih zrna grada. Kada zrno grada dođe u oblast gde su temperature više od 0°C počinje da se topi. Mala zrna grada se uglavnom otope i pretvore u krupne kišne kapi pre nego što dospeju na tlo. Velika zrna grada stižu do tla još uvek smrznuta (sa prečnikom većim od 5 mm) i beleže se kao grad. Na slici 1 su prikazani emagrami osmotreni 23. juna 2024. g. u 00 UTC u Beogradu i u 12 UTC u Nišu, zajedno sa hodografima i izračunatim parametrima stabilnosti. Slika 2 prikazuje zrna grada koja su nastala u toj superćeliji.
      </p>` +
        `<p style="color: #000; font-size: 14px;">
Cusack, S., Cox, T., 2024. Brief communication: Investigating trends in European hailstorm damage using CMIP6-DAMIP climate models.
 <a
  href="http://dx.doi.org/10.5194/nhess-2024-210"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  http://dx.doi.org/10.5194/nhess-2024-210
</a>

, <br>Natural Hazards Earth System Sciences Discussions [preprint]. URL: <a
  href="https://nhess.copernicus.org/preprints/nhess-2024-210"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  https://nhess.copernicus.org/preprints/nhess-2024-210
</a>.
        </p>`,
      content: [
        {
          type: "images-side-by-side",
          images: [
            `<img src="${imageGradUvod}" alt="Grad Uvod">`,
            `<img src="${imageGradUvod2}" alt="Emagrami">`,
          ],
          desc: `<p>Slika 1 Emagrami sa hodografom i izračunatim parametrima stabilnosti za 23. jun 2024. g. u 00 UTC za Beograd i u 12 UTC za Niš.</p>`,
        },

        {
          type: "images-side-by-side",
          images: [
            `<img src="${imageGradUvod3}" alt="Grad u Sjenici slika">`,
            `<img src="${imageGradUvod4}" alt="Grad u Sjenici">`,
          ],
          desc: `<p>Slika 2 Grad u Sjenici, 23. juna 2024. godine (foto: Vladan Vučković) </p>`,
        },
      ],
    },
    {
      label: "METODOLOGIJA",
      value: "metodologija",
      desc:
        `<h2>METODOLOGIJA</h2>
      <p style="margin-bottom: 10px; color: #000;">
     U Srbiji se grad javlja uglavnom u toplom delu godine, od aprila do septembra (u oko 97% slučajeva). U ostalom delu godine se javlja vrlo retko, što je prikazano na slici 1. Grad se najčešće javlja u popodnevnim satima, u oko 70% svih slučajeva u periodu od 14 do 18 h, a u 92,4% u periodu od 12–21 h, slika 2). Da bi se ublažile štete od grada, u Srbiji se sprovodi zasejavanje oblaka sa tla, raketama koje su napunjene sa 400 gr pirotehničke smeše koja sadrži u sebi oko 8% srebro-jodida. Republički hidrometeorološki zavod Srbije sprovodi suzbijanje grada sa glavnim ciljem smanjenja učestanosti pojave grada ili smanjenja prečnika zrna grada. Konačan cilj je ublažavanje eventualne štete na usevima i materijalnim dobrima. Radi toga je napravljena gusta mreža raketnih lansirnih stanica (RLS), znatno gušća (na manjem rastojanju) od sinoptičkih i klimatoloških stanica. Na tim stanicama radi obučeno osoblje koje beleži pojave koje konvektivni oblaci proizvode: kišu, grmljavinu, jak vetar, grad, sugradicu, grad, kao i veličinu zrna grada. Pošto je grad pojava malih razmera (zahvata oblasti koje su dužine od 20 do 25 km, a širine 200 m do 4 km), podaci sa RLS su najpouzdaniji i najbolji raspoloživi za analizu grada, jer grad može da padne između dve meteorološke stanice i na taj način ne bude zabeležen na njima. Merenje preovlađujuće veličine zrna grada se vrši vizuelno, tako što osmatrač poredi veličinu zrna grada sa nekim od poznatih predmeta (zrno pasulja, orah, lešnik). U praksi Republičkog hidrometeorološkog zavoda se koristi sedam klasa grada (kodovi 1–7, tabela 1) i sugradica, kao zrno leda koje je manje od kukuruznog zrna (kod 0). 
</p>` +
        `<p style="margin-bottom: 10px; color: #000; font-size: 18px; font-style: italic;"> 
        Raspodela zrna grada po veličini
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
U periodu 2002–2015, u Srbiji je u skoro 80% pojava veličina zrna grada bila manja od veličine lešnika. Kod nas veoma retko padaju zrna grada veća od golubijeg jajeta, bilo ih je svega oko 0,8% u posmatranom periodu. Udeo krupnog grada, većeg od kokošijeg jajeta, je zanemarljiv i javlja se u 0,01% slučajeva. Slična raspodela zrna grada po veličinama je osmotrena i za period 1981–2015, za područje Srbije bez Vojvodine, s tim što je u tom periodu raspodela bila pomerena ka većim zrnima grada. Postavilo se pitanje da li je pomeranje raspodele grada ka manjim veličinama bilo posledica uticaja orografije, jer je Vojvodina uglavnom ravna. Zato je urađena analiza raspodele padavina grada za isti period 2002–2015 za oblast Srbije bez Vojvodine. Raspodela je bila vrlo slična onoj koja je dobijena za celu oblast Srbije. Na osnovu toga je zaključeno da je u skorijem periodu (2002–2015) bilo više padavina manjih zrna grada.
      </p>` +
        `<p style="margin-bottom: 10px; color: #000; font-size: 18px; font-style: italic;"> 
        Trajanje grada
</p>` +
        `<p style="margin-bottom: 16px; color: #000;">
U više od 55% slučajeva, grad je padao 1–2 minuta (slika 3), a u 75% slučajeva manje od 5 min. Grad dugog trajanja se retko beleži. U svega 8% slučajeva grad je trajao 10 minuta i više. Srednje trajanje padavina grada je oko 3,5 minuta. Postoji značajan trend smanjenja prosečnog sezonskog trajanja grada od -0,0312 min/god na nivou značajnosti α = 0,001.      
</p>` +
        `<p style="color: #000; font-size: 14px;">
Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15),6556-6572 (DOI:10.1002/joc.7212). 
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradMetodologija1}" alt="METODOLOGIJA Grad">`,
          desc: `Slika 1 Čestina pojave grada i sugradice u Srbiji u periodu 2002–2015. godine. Ukupan broj pojava grada i sugradice je bio 23353, a od toga je 97,4% pojava osmotreno u toplom delu godine (najviše u maju, junu i julu), a svega 0,4% u oktobru.`,
        },
        {
          type: "image-full",
          image: `<img src="${gradMetodologija2}" alt="METODOLOGIJA Grad">`,
          desc: `Slika 2 Raspodela pojave grada u toku dana`,
        },

        {
          type: "table",
          content: `
          <table class="min-w-full border-collapse border border-gray-300">
  <thead>
    <tr class="bg-gray-100">
      <th class="border border-gray-300 px-2 py-1">Kod</th>
      <th class="border border-gray-300 px-2 py-1">Prečnik zrna grada (mm)</th>
      <th class="border border-gray-300 px-2 py-1">Veličina zrna grada</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="border border-gray-300 px-2 py-1">0</td>
      <td class="border border-gray-300 px-2 py-1">0,1 – 3,0</td>
      <td class="border border-gray-300 px-2 py-1">Sugradica</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">1</td>
      <td class="border border-gray-300 px-2 py-1">4 – 8</td>
      <td class="border border-gray-300 px-2 py-1">Zrno kukuruza</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">2</td>
      <td class="border border-gray-300 px-2 py-1">9 – 12</td>
      <td class="border border-gray-300 px-2 py-1">Zrno pasulja</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">3</td>
      <td class="border border-gray-300 px-2 py-1">13 – 20</td>
      <td class="border border-gray-300 px-2 py-1">Lešnik</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">4</td>
      <td class="border border-gray-300 px-2 py-1">21 – 30</td>
      <td class="border border-gray-300 px-2 py-1">Orah</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">5</td>
      <td class="border border-gray-300 px-2 py-1">31 – 35</td>
      <td class="border border-gray-300 px-2 py-1">Golubije jaje</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">6</td>
      <td class="border border-gray-300 px-2 py-1">36 – 50</td>
      <td class="border border-gray-300 px-2 py-1">Kokošije jaje</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">7</td>
      <td class="border border-gray-300 px-2 py-1">&gt; 50</td>
      <td class="border border-gray-300 px-2 py-1">Veće od kokošijeg jajeta</td>
    </tr>
  </tbody>
</table>

        `,
          desc: `<p>Tabela 1 Prečnik zrna grada saglasno kodiranju koje vrši Republički hidrometeorološki zavod.</p>`,
        },

        {
          type: "image-full",
          image: `<img src="${gradMetodologija4}" alt="METODOLOGIJA Grad">`,
          desc: `Slika 3 Relativna frekvencija trajanja grada i sugradice`,
        },
      ],
    },
    {
      label: "TRENDOVI",
      value: "trendovi",
      desc: `<h2>TRENDOVI</h2>
      <p style="margin-bottom: 10px; color: #000;">
Na slici 1 je prikazan godišnji broj dana sa gradom i sugradicom za područje Srbije, bez Vojvodine, za period od 1981–2015. g. Najveći broj dana sa gradom, 83, je osmotren 2002. g. Izračunate su godišnje prosečne vrednosti za dva potperioda, 1981–1998 i 2000–2015, i te vrednosti su redom 48,5 i 56,9 dana. Dakle, za poslednjih 16 godina u periodu, prosečan broj dana sa gradom je bio veći nego za prvih 17 godina. Linearna regresija pokazuje rastući trend. Međutim, ovaj trend nije statistički značajan, jer je koeficijent determinacije veoma mali, R2 = 0,0629, pa se može zaključiti da nema linearnog trenda u godišnjem broju dana sa gradom i sugradicom, ali je pozitivni monotoni trend intenziteta 0.308 dana/god vrlo verovatan na nivou poverenja od 0,05. Traženi su trendovi i za pojedinačne mesece, i samo je uočen monotoni trend od 0.136 dana/god za mesec maj (α=0,05).
      </p>
      <p style="margin-bottom: 10px; color: #000;">
Ukupan broj pojava grada i sugradice je prikazan na slici 2. Može se uočiti veoma promenljiva priroda grada. Najmanji broj pojava od 551 je zabeležen 2015. godine, kada je broj aktivnih RLS bio 1364. Najveći broj pojava od 1957 je zabeležen 2007. godine u mreži od 1633 RLS. Nije uočen statistički značajan linearan trend broja pojava grada i sugradice. Man–Kendalov test nije pokazao postojanje monotonog trenda, kako ukupno, za sve veličine zrna grada, tako ni za pojedinačne veličine. Zanimljivo je da postoji rastući monotoni trend od 6,25 pojava/god koji je značajan na nivou značajnosti od 6,7% za veličine grada manje od zrna kukuruza (sugradica).
        </p>
        <p style="margin-bottom: 10px; color: #000;">
        Za potrebe projekta EXTREMES, analiziran je broj dana sa ekstremnim gradom u periodu 2005–2020. Ekstremni grad je definisan kao grad sa prečnikom većim od 21 mm (kodovi 4, 5, 6 i 7). On je u posmatranom periodu činio 20.8% svih dana sa gradom i prikazan je na slici 3. Prema jednačini linearne regresije, broj dana sa gradom prečnika od 21 do 30 mm (kod 4) se neznatno povećava sa vremenom: 0,6 dana za 16 godina. Međutim, zbog velike p-vrednosti (p = 0,794), ovo nije statistički značajan trend. Nagib linearne regresije za dane sa gradom prečnika 31–35 mm (kod 5) je nula, a p-vrednost ukazuje da nije statistički značajan. Broj dana sa najvećim zrnima grada, prečnika 36–50 mm se smanjuje, ali ni ovaj trend nije statistički značajan. Bila su osmotrena samo dva dana sa gradom koji je bio veći od 50 mm (kod 7), tako da se za tu kategoriju ne može odrediti trend. Takođe, Man-Kendalov test ne pokazuje monotone trendove za dane sa ovim ekstremnim padavinama grada. Stoga možemo zaključiti da se broj dana sa ekstremnim gradom nije povećavao u analiziranom periodu 2005–2020.
      </p>
      <ul style="margin-bottom: 16px; color: #000; padding-left: 20px; list-style: disc;">
      <li>Nema linearnog trenda u broju dana sa gradom i sugradicom, ali postoji pozitivan monotoni trend od 0.308 dana/god (α=0,05).</li>
      <li>Nema trenda na 5% nivou značajnosti u pojavi grada i sugradice ni za jednu veličinu zrna grada.</li>
      <li>Postoji pozitivan monotoni trend pojave sugradice od 6,25 dana/god, sa rizikom od 6,71%.</li>
      <li>Nema trenda u učestalosti grada i sugradice.</li>
      <li>Padavine grada i sugradice kraće traju, tj. postoji opadajući trend trajanja grada (-0,0312 min/god).</li>
      <li>Prva pojava grada i sugradice se ne javlja ranije u sezoni.</li>
      <li>Broj dana sa ekstremnim gradom se ne povećava.</li>
    </ul>
    <p style="color: #000; font-size: 14px;">
Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15),6556-6572 (DOI:10.1002/joc.7212).
<br>
Vujović D, Vučković V, Zečević A, 2025. Analysis and Trends of the Stability Indices During Hail Days Derived from the Radiosonde Observations from Belgrade (Serbia). Atmosphere, 16(5), 520,
<a 
  href="https://doi.org/10.3390/atmos16050520"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  https://doi.org/10.3390/atmos16050520
</a>
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradTrendovi1}" alt="Slika 1 Broj dana sa gradom i sugradicom na teritoriji Srbije bez Vojvodine, 1981–2015.">`,
        },
        {
          type: "text",
          content: `<p style="font-size: 14px;">Slika 1 Broj dana sa gradom i sugradicom na teritoriji Srbije bez Vojvodine, 1981–2015. Puna i tačkasta crna linija su 5-ogodišnji i 10-ogodišnji pokretni srednjak, redom.</p>`,
        },
        {
          type: "image-full",
          image: `<img src="${gradTrendovi2}" alt="Slika 2 Godišnji broj pojava grada i sugradice na teritoriji Srbije, bez Vojvodine, 1981–2015.">`,
        },
        {
          type: "text",
          content: `<p style="font-size: 14px;">Slika 2 Godišnji broj pojava grada i sugradice na teritoriji Srbije, bez Vojvodine, 1981–2015.</p>`,
        },
        {
          type: "image-full",
          image: `<img src="${gradTrendovi3}" alt="Slika 3 Broj dana kada je osmotren ekstreman grad">`,
        },
        {
          type: "text",
          content: `<p style="padding-left: 2%; padding-right:2%; font-size: 14px;">Slika 3 Broj dana kada je osmotren ekstreman grad (kodovi četiri, pet i šest) u periodu 2005–2020. godina. Prikazana je i linearna regresija. R2, t i p su koeficijenti determinacije, t-statistika i p-vrednost, redom.</p>`,
        },
      ],
    },
    {
      label: "KLIMATOLOGIJA",
      value: "klimatologija",
      desc: `<h2>KLIMATOLOGIJA GRADA</h2>
<p style="margin-bottom: 10px; color: #000;">
Prosečan godišnji broj dana sa padavinama grada i sugradice za svaku raketnu lansirnu stanicu (RLS) je dat na slici 1. Aktivnih RLS je bilo oko 1600. Ovo je prva klimatologija grada u Srbiji ove vrste. Prosečan godišnji broj dana sa gradom po RLS je bio od 0 do 2,9. Na samo jednoj RLS (RLS Hetin, opština Žitište) grad nije uopšte osmotren tokom 10 godina u toku kojih je bila aktivna. Na čak 70% svih RLS, prosečan godišnji broj dana sa padavinama grada i sugradice je bio manji od jednog dana. Prosek od dva ili više dana sa ovim padavinama je zabeležen na 23 RLS. Najveća učestalost grada je osmotrena u jugozapadnom planinskom delu Srbije, sa srednjom vrednošću od 1,2 dana po godini po RLS (minimum 0,3, maksimum 2,7 dana). Tokom toplog dela godine, viša je temperatura vazduha, pa je i razvoj kumulonimbusa češći i intenzivniji. U planinskim oblastima postoji i dodatno, prisilno uzlazno strujanje vazduha, čime se povećava verovatnoća da se razvije jaka konvekcija, koja može dati grad.
</p>
<p style="margin-bottom: 10px; color: #000;">
Frekvencija grada opada ka istoku i severu. U Vojvodini srednji godišnji broj dana sa gradom i sugradicom po RLS je 0,7 dana. Na Fruškoj gori je taj broj malo veći i iznosi 1,9 dana godišnje po RLS. Područje sa povećanim prosečnim godišnjim brojem dana sa gradom se proteže duž planina: na jugozapadu (planina Cer, 689 m.n.v. i Valjevske planine, 1346 m.n.v.), u Centralnoj Srbiji (planina Rudnik, 1132 m.n.v.), Zapadnoj Srbiji (Jelica (929 m.n.v.), Javor (1519 m.n.v.), Golija (1833 m.n.v.)), jugoistoku (Jastrebac (1492 m.n.v.), Radan (1408 m.n.v.)). Drugi, manje izražen, krak povećane učestanosti prosečnog godišnjeg broja dana sa gradom i sugradicom se proteže preko planina istočne Srbije.
</p>
<p style="margin-bottom: 10px; color: #000;">
Jasno je izražena godišnja promenljivost padavina sugradice i grada. U pojedinačnim godinama posmatranog perioda, na 86 do 99% aktivnih RLS su zabeležena najviše 2 dana sa gradom, ali je bilo i godina kada je ova pojava zabeležena više od 5 dana na jednoj stanici. Maksimum od 10 dana sa gradom u jednoj godini je zabeležen 1983. g. na RLS Izvor, opština Svrljig i 1986. g. na RLS Amzići, opština Nova Varoš. Obe stanice se nalaze u planinskoj oblasti.
</p>
<p style="color: #000; font-size: 14px;">
        Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15),6556-6572 (DOI:10.1002/joc.7212).
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradKlimatologija}" alt="Klimatologija Grada" style="max-width:100%;height:auto;">`,
          desc: `Slika 1 Prosečan godišnji broj dana sa gradom i sugradicom po raketno lansirnoj stanici u Srbiji tokom perioda 1981–2005 godina. Svaka tačka predstavlja položaj jedne RLS-e.`,
        },
      ],
    },
    {
      label: "ŠTETE OD GRADA",
      value: "stete",
      desc: `<h2>ŠTETE OD GRADA</h2>
<p style="margin-bottom: 10px; color: #000;">
Cilj zasejavanja oblaka je smanjenje veličine zrna grada, čime se može minimizirati potencijalna šteta na poljoprivrednim usevima i materijalnim dobrima. Pošto nije moguće potpuno sprečiti štetu koju izaziva grad, podaci o šteti se prikupljaju kako bi se procenila efikasnost sistema odbrane od grada. Prvenstveno su analizirane štete na usevima sa individualnih i opštinskih parcela. Analiza je vršena na osnovu podataka koji su dobijeni od opštinskih službi, kao i od komisije stručnjaka iz Republičkog hidrometeorološkog zavoda Srbije.
</p>
<p style="margin-bottom: 10px; color: #000;">
U periodu 2002–2018 bilo je 597 dana sa štetama od grada na usevima, a 1078 dana kada je grad osmotren. Osrednjeno, bila su 33,2 dana sa štetom od grada po godini, u poređenju sa 63,4 dana sa gradom i sugradicom. Najveća oštećena površina u jednom danu je bila 18914,96 ha 21. avgusta 2004. g, kada je jaka oluja zahvatila Vojvodinu. U srednjem, godišnje je bila oštećena površina od 51433 ha, nezavisno od procenta štete, što čini 1,01% ukupne poljoprivredne površine. Srednja godišnja oštećena površina svedena na 100% oštećenja je bila 22414 ha, što čini 0,44% ukupne poljoprivredne površine. Pre nego što je uveden sistem odbrane od grada, to oštećenje je bilo oko 3% ukupne poljoprivredne površine.
</p>
<p style="margin-bottom: 10px; color: #000;">
Na slici 1 je prikazan godišnji broj dana sa gradom (NHD) i dana sa štetom od grada na poljoprivrednim usevima (NDD) u Srbiji u periodu 2002–2018. g. Mesečna raspodela broja pojava grada (NHO) i površina poljoprivrednih useva oštećenih gradom (HDA) za isti period se može videti na slici 2. Srednji godišnji broj dana sa štetom od grada na usevima za svaku opštinu je prikazan na slici 3, a na slici 4 srednja godišnja površina sa štetom od grada na usevima (izražena u procentima) za svaku opštinu.
</p>
<p style="color: #000; font-size: 14px;">
Nađ J, Kardum Đ, Vujović D, 2024. Damage to crops caused by hail in Serbia. 4th European Hail Workshop, Karlsruhe, Germany, March 5-7, 2024
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradStete1}" 
          alt="Slika 1 Godišnji broj dana sa gradom (NHD) i dana sa štetom od grada na poljoprivrednim usevima (NDD) u Srbiji u periodu 2002–2018." 
          style="max-width:100%;height:auto;">`,
          desc: `Slika 1 Godišnji broj dana sa gradom (NHD) i dana sa štetom od grada na poljoprivrednim usevima (NDD) u Srbiji u periodu 2002–2018.`,
        },
        {
          type: "image-full",
          image: `<img src="${gradStete2}" 
          alt="Slika 2 Mesečna raspodela broja pojava grada (NHO) i površina poljoprivrednih useva oštećenih gradom (HDA) u periodu 2002–2018." 
          style="max-width:100%;height:auto;">`,
          desc: `Slika 2 Mesečna raspodela broja pojava grada (NHO) i površina poljoprivrednih useva oštećenih gradom (HDA) u periodu 2002–2018.`,
        },
        {
          type: "images-side-by-side-desc",
          images: [
            {
              img: `<img src="${gradStete3}" alt="Slika 3">`,
              desc: "Slika 3 Srednji godišnji broj dana sa štetom od grada na usevima za svaku opštinu.",
            },
            {
              img: `<img src="${gradStete4}" alt="Slika 4">`,
              desc: "Slika 4 Srednja godišnja površina sa štetom od grada na usevima (izražena u procentima) za svaku opštinu.",
            },
          ],
        },
      ],
    },

    {
      label: "PODACI",
      value: "podaci",
      content: [
        <div className="suseDeo flex flex-col md:flex-row">
          {/* LEVI DEO */}
          <div className="suseDeoVeci w-full md:w-3/5 p-4">
            <div className="flex flex-col md:flex-row md:items-end md:gap-6">
              {/* IZBOR KODA */}
              <div className="flex flex-col">
                <label className="font-semibold mb-2">
                  Izaberi veličinu zrna grada:
                </label>
                <select
                  value={hailCode}
                  onChange={(e) => setHailCode(e.target.value)}
                  className="border p-2 w-full md:w-56 rounded-xl"
                >
                  <option value="5">Kod 5 (31–35 mm)</option>
                  <option value="6">Kod 6 (36–50 mm)</option>
                  <option value="7">Kod 7 (&gt; 50 mm)</option>
                </select>
              </div>

              {/* IZBOR DATUMA */}
              <div className="flex flex-col">
                <label className="font-semibold mb-2">Izaberi datum:</label>
                <select
                  value={hailDate}
                  onChange={(e) => setHailDate(e.target.value)}
                  className="border p-2 w-full md:w-56 rounded-xl"
                >
                  {GRAD_DATA[hailCode].map((item) => (
                    <option key={`${item.file}-${item.date}`} value={item.file}>
                      {item.date}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* SLIKA */}
            <div className="mt-4">
              <img
                src={`/grad/${hailDate}`}
                alt="Ekstreman grad"
                className="max-w-full mx-auto border"
              />
            </div>
            {/* DUGMAD ZA PREUZIMANJE iskljuceno 
            <div className="mt-6 flex flex-col md:flex-row justify-center gap-4">
              
              <a
                href={`/grad/${hailDate}`}
                download={hailDate}
                className="bg-blue-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi sliku
              </a>

             
              <a
                href={GRAD_ZIP_DATA[hailCode]}
                download
                className="bg-green-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi podatke
              </a>

              
              <a
                href="/grad-data/extremes-grad-emagram-svi-kodovi.zip"
                download
                className="bg-red-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi sve podatke
              </a>
            </div>
            */}
          </div>

          {/* DESNI DEO */}
          <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
            <h4 className="font-semibold mb-2">GRAD</h4>
            <p className="text-black">
              Vertikalni profil atmosfere prikazan emagramima, hodografi i
              izračunati indeksi nestabilnosti za dane kada je osmotren
              ekstreman grad u Srbiji.
            </p>
            <p className="text-black">
              Sondaže sa izračunatim indeksima za period 2020-2024 za Beograd
              možete preuzeti &nbsp;
              <a
                href="http://haos.ff.bg.ac.rs/.extremes/grad/emagram/bgd2.tar.gz"
                className="text-blue-700 hover:text-[#1D4ED8] hover:underline"
              >
                ovde
              </a>
              , a za Niš &nbsp;
              <a
                href="http://haos.ff.bg.ac.rs/.extremes/grad/emagram/nis2.tar.gz"
                className="text-blue-700 hover:text-[#1D4ED8] hover:underline"
              >
                ovde
              </a>
              .
            </p>
          </div>
        </div>,
      ],
    },
  ];

  return (
    <>
      {isTabletOrLarger && <NavBar />}
      {isSmallDevice && <NavBarMobile />}
      <div className="container mx-auto text-center min-h-screen md:mb-6 ">
        <Tabs value={activeTab} className="max-w-screen-xl mx-auto">
          <TabsHeader
            className="bg-transparent flex justify-center flex-wrap md:flex-nowrap mx-2 md:mx-0"
            indicatorProps={{
              className: "bg-gray-900/10 shadow-none !text-gray-900",
            }}
            onChange={(value) => setActiveTab(value)}
          >
            {data.map(({ label, value }) => (
              <Tab className="probaTaba2" key={value} value={value}>
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody>
            {data.map(({ value, tabs, desc }) => (
              <TabPanel key={value} value={value}>
                {value === "podaci" ? (
                  data.find((d) => d.value === "podaci")?.content
                ) : (
                  <>
                    {/* Prikaz za ostale glavne tabove kao što su Uvod, Metodologija itd. */}
                    <div className="suseDeo flex flex-col md:flex-row">
                      <div className="suseDeoVeci w-full md:w-3/5 p-4">
                        {/* Use the flexible content component */}
                        <FlexibleContent
                          items={
                            value === "podaci"
                              ? []
                              : data.find((d) => d.value === value)?.content ||
                                []
                          }
                        />
                      </div>
                      <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
                        {desc && ReactHtmlParser(desc)}
                      </div>
                    </div>
                  </>
                )}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <Form />
      <Footer />
    </>
  );
}
